import Footer from "./comm/Footer";
import Navbar from "./comm/Navbar";
import OurWorkSlider from "./brand_Slider";


function Service() {
    return (
        <>
            <Navbar />

            {/* Services Section */}
            <section className="py-5">
                <div className="container">
                    <h2 className="service_title text-center">OUR TAILORING SERVICES</h2>
                    <div className="service_underline mx-auto"></div>
                    <div className="row g-4">
                        <div className="col-md-4 mt-4 mb-4">
                            <div className="service_card">
                                <img
                                    src="https://assets.myntassets.com/w_412,q_60,dpr_2,fl_progressive/assets/images/27748182/2024/2/21/f7c1aabb-1505-4630-bd25-53eb15a153711708492338173TwoPieceNavyTexturedFormalSuits-Waves1.jpg"
                                    alt="Beige suit"
                                    className="service_image"
                                />
                                <div className="service_overlay">
                                    <div className="service_marker"></div>
                                    <div className="service_name">SUIT</div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-4 mt-4 mb-4">
                            <div className="service_card">
                                <img
                                    src="https://imagescdn.louisphilippe.com/img/app/product/8/896216-13787432.jpg?auto=format&w=390"
                                    alt="Formal shirt"
                                    className="service_image"
                                />
                                <div className="service_overlay">
                                    <div className="service_marker"></div>
                                    <div className="service_name">SHIRT</div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-4 mt-4 mb-4">
                            <div className="service_card">
                                <img
                                    src="https://pantproject.com/cdn/shop/files/angled_view_with_a_close_fit_of_Pant_Project_raven_black_stretchable_trousers.jpg?v=1726637258"
                                    alt="Navy pant"
                                    className="service_image"
                                />
                                <div className="service_overlay">
                                    <div className="service_marker"></div>
                                    <div className="service_name">PANT</div>
                                </div>
                            </div>
                        </div>

                        {/* //// */}

                        <div className="col-md-4 mt-4 mb-4">
                            <div className="service_card">
                                <img
                                    src="https://imagescdn.louisphilippe.com/img/app/product/3/39632887-13137512.jpg?auto=format&w=390"
                                    alt="Blazer"
                                    className="service_image"
                                />
                                <div className="service_overlay">
                                    <div className="service_marker"></div>
                                    <div className="service_name">Blazer</div>
                                </div>
                            </div>
                        </div>


                        <div className="col-md-4 mt-4 mb-4">
                            <div className="service_card">
                                <img
                                    src="https://kajols.com/cdn/shop/products/pink-engagement-jacquard-jodhpuri-suit-241202-1000x1375.jpg?v=1669636370"
                                    alt="Jodhpuri suit"
                                    className="service_image"
                                />
                                <div className="service_overlay">
                                    <div className="service_marker"></div>
                                    <div className="service_name">JODHPURI</div>
                                </div>
                            </div>
                        </div>


                        <div className="col-md-4 mt-4 mb-4">
                            <div className="service_card">
                                <img
                                    src="https://images.wholesalesalwar.com/2024y/September/52679/Sea%20Blue-Banarasi%20Silk-Wedding%20Wear-Digital%20Print-Radymade%20Modi%20Jacket%20Kurta%20Pajama-3249%20(4).jpg"
                                    alt="Modi Jacket"
                                    className="service_image"
                                />
                                <div className="service_overlay">
                                    <div className="service_marker"></div>
                                    <div className="service_name">MODI JACKET</div>
                                </div>
                            </div>
                        </div>

                        {/* /// */}

                        <div className="col-md-4 mt-4 mb-4">
                            <div className="service_card">
                                <img
                                    src="https://img.faballey.com/images/Product/XMS00225Z/3.jpg"
                                    alt="kurta"
                                    className="service_image"
                                />
                                <div className="service_overlay">
                                    <div className="service_marker"></div>
                                    <div className="service_name">KURTA</div>
                                </div>
                            </div>
                        </div>


                        <div className="col-md-4 mt-4 mb-4">
                            <div className="service_card">
                                <img
                                    src="https://rajanyas.com/cdn/shop/files/1K2A1852_ef0e7781-3c02-4a10-b5a6-207936185ad8.jpg?v=1718718966&width=1946"
                                    alt="Beige suit"
                                    className="service_image"
                                />
                                <div className="service_overlay">
                                    <div className="service_marker"></div>
                                    <div className="service_name">PATHANI KURTA</div>
                                </div>
                            </div>
                        </div>


                        <div className="col-md-4 mt-4 mb-4">
                            <div className="service_card">
                                <img
                                    src="https://shreeman.in/cdn/shop/products/DSC3426.jpg?v=1650721591"
                                    alt="Beige suit"
                                    className="service_image"
                                />
                                <div className="service_overlay">
                                    <div className="service_marker"></div>
                                    <div className="service_name">SHERWANI</div>
                                </div>
                            </div>
                        </div>

                        {/* /// */}

                        <div className="col-md-4 mt-4 mb-4">
                            <div className="service_card">
                                <img
                                    src="https://cdn.sareesaga.com/image/cache/data18/indo-western-sherwani-buttons-fancy-fabric-in-blue-215261-1000x1375.jpg"
                                    alt="Indo Western Sherwani"
                                    className="service_image"
                                />
                                <div className="service_overlay">
                                    <div className="service_marker"></div>
                                    <div className="service_name">INDOWESTERN</div>
                                </div>
                            </div>
                        </div>


                        <div className="col-md-4 mt-4 mb-4">
                            <div className="service_card">
                                <img
                                    src="https://sayyedalitailor.com/wp-content/uploads/2024/03/0a0a0944-1000x1000-1.jpg"
                                    alt="Safaari"
                                    className="service_image"
                                />
                                <div className="service_overlay">
                                    <div className="service_marker"></div>
                                    <div className="service_name">SAFARI</div>
                                </div>
                            </div>
                        </div>


                        <div className="col-md-4 mt-4 mb-4">
                            <div className="service_card">
                                <img
                                    src="https://www.sainly.com/cdn/shop/files/men_selegantweddingsuit_3.jpg?v=1697781757"
                                    alt="waistcoat"
                                    className="service_image"
                                />
                                <div className="service_overlay">
                                    <div className="service_marker"></div>
                                    <div className="service_name">WAISTCOAT</div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            <section className="py-3">
                <div className="container">
                    <div className="mb-1">
                        <h2 className="brand-title">FABRIC BRANDS WE USE</h2>
                        <div className="brand-underline"></div>
                    </div>
                    <OurWorkSlider />
                </div>
            </section>

            {/* Professional section */}

            <section className="cta-section py-5">
                <div className="container">
                    <div className="cta-container">
                        <div className="cta-content">
                            <h2 className="cta-title">Experience Bespoke Tailoring</h2>
                            <p className="cta-text">
                                Schedule a private consultation with our master tailors to create your perfect garment
                            </p>
                        </div>
                        <div className="cta-action">
                            <a href="/appointment">
                                <button className="cta-button">
                                    <span>Book Appointment</span>
                                </button>
                            </a>
                            <a href="/contact" className="cta-link">Have questions? Contact us</a>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />
        </>
    );
};

export default Service;